import { gql } from "@apollo/client";

export const GET_PROFESIONALES_REQUISITOS = gql`
query profesionalesRequisitos( $idDelegacion: Int!) {
    profesionalesRequisitos( idDelegacion: $idDelegacion){
        valorEsperado {
            idProfesional
            nombre
            apellido
            idTipoProfesional
        }
    }
}`;

export const adaptProfesional = (profesional) => {
  return {
    idProfesional: profesional?.idProfesional,
    nombre: `${profesional?.apellido}, ${profesional?.nombre}`,
    tipoProfesional: profesional?.idTipoProfesionalNavigation?.descripcion || '',
    idTipoProfesional: profesional?.idTipoProfesional
  };
};

export const adaptProfesionalesRequisitosArray = (
profesionales) =>
{
  return structuredClone(profesionales?.valorEsperado)?.
  map((profesional) => adaptProfesional(profesional));
};